import { Autocomplete } from '@base-ui/react/autocomplete';
import type { ReactNode, RefObject } from 'react';

type SearchPopupProps = {
    anchorRef: RefObject<HTMLDivElement | null>;
    children?: ReactNode;
    isFullscreen: boolean;
    portalContainer: HTMLElement;
};

export function SearchPopup({ anchorRef, children, isFullscreen, portalContainer }: SearchPopupProps) {
    return (
        <Autocomplete.Portal container={portalContainer}>
            <Autocomplete.Positioner
                align="start"
                anchor={isFullscreen ? portalContainer : anchorRef}
                collisionPadding={0}
                positionMethod={isFullscreen ? 'fixed' : 'absolute'}
                side="bottom"
                sideOffset={isFullscreen ? 0 : 1}
                className={
                    isFullscreen
                        ? 'header-search__positioner header-search__positioner--fullscreen'
                        : 'header-search__positioner'
                }
            >
                <Autocomplete.Popup className="header-search__popup">{children}</Autocomplete.Popup>
            </Autocomplete.Positioner>
        </Autocomplete.Portal>
    );
}
